"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-di-casio": {
    "8fe84e12": [{
      "hkey": "0c1ba291",
      "slug": "casola",
      "name": "Casola",
      "primary": true,
      "skipSearch": false
    }],
    "casola-berzantina": [{
      "hkey": "0c1ba291",
      "slug": "casola",
      "name": "Casola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6064e732": [{
      "hkey": "d8c1827a",
      "slug": "castel-di-casio",
      "name": "Castel di Casio",
      "primary": true,
      "skipSearch": false
    }],
    "pieve": [{
      "hkey": "d8c1827a",
      "slug": "castel-di-casio",
      "name": "Castel di Casio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a46d89f1": [{
      "hkey": "1e61df9f",
      "slug": "prati-speranza",
      "name": "Prati-Speranza",
      "primary": true,
      "skipSearch": false
    }],
    "prati": [{
      "hkey": "1e61df9f",
      "slug": "prati-speranza",
      "name": "Prati-Speranza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;